import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lines, (line) => {
      return (_openBlock(), _createBlock(_component_skeleton_line, { key: line }))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}